<div class="d-flex justify-content-center m">
  <div class="card">
    <div class="card-header text-center">
      <h4 class="display-5">Send Event To Students</h4>
    </div>
    <form #uploadform="ngForm" name="uploadform" class="ml-5 mr-5 mt-4">

      <div class="mb-3">
        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="name" class="legend">Subject: <span class="requiredfield">*</span></label>
              <input class="text-field" required type="text" id="mailSubject" name="mailSubject"
                [(ngModel)]="mailSubject" autofocus>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Subject"
                class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">The subject line of the invitation. It is also used as the title of the meeting if you generate a link below.</p>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="name" class="legend">Venue/link: <span class="requiredfield">*</span></label>
              <input class="text-field" required type="text" id="venue" name="venue" [(ngModel)]="venue">
          <button class="generate-meeting-link-button btn wlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto align-items-center px-3 bg-transparent border-0 text-body" title="Generate Meeting Link" (click)="getMeetingID()" [disabled]="this.headerinfo.pageloading" [hidden]="!!venue"><i class="fas fa-plus"></i></button>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Venue or link"
                class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">Where the event takes place. Type an address, paste a link, or use the plus button to generate a meeting link. Fill in the subject first if you want a generated link.</p>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="startt" class="legend">Event StartDate: <span class="requiredfield">*</span></label>
              <input [owlDateTime]="rawStartTime" class="text-field" id="inviteStartDate" name="inviteStartDate"
                [(ngModel)]="inviteStartDate">
              <button [owlDateTimeTrigger]="rawStartTime" type="button"
                class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                title="Calendar"><i class="fa fa-calendar"></i></button>
              <owl-date-time #rawStartTime></owl-date-time>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Event start date"
                class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">When the event begins, in your own time zone.</p>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="fieldset fieldset--lg">
              <label for="endt" class="legend">Event EndDate: <span class="requiredfield">*</span></label>
              <input [owlDateTime]="rawEndTime" class="text-field" id="inviteEndDate" name="inviteEndDate"
                [(ngModel)]="inviteEndDate">
              <button [owlDateTimeTrigger]="rawEndTime" type="button"
                class="owlDateTimeTrigger position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                title="Calendar"><i class="fa fa-calendar"></i></button>
              <owl-date-time #rawEndTime></owl-date-time>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Event end date"
                class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">When the event finishes. It has to be after the start date.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="fieldset fieldset--lg" *ngIf="lessons">
              <label class="legend" for="allowEnroll">Lesson:</label>
              <select class="text-field" [(ngModel)]="lessonId" name="lessonId">
                <option *ngFor="let lesson of lessons" [ngValue]="lesson.id">
                  {{lesson.title}}
                </option>
              </select>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson"
                class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">Ties the event to one of the course's lessons, so it is listed against that lesson. Optional.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="fieldset fieldset--lg " *ngIf="allowBatch">
              <label class="legend" for="allowEnroll">Batch: <span class="requiredfield">*</span></label>
              <select class="text-field" [(ngModel)]="selectedBatchId" name="selectedBatchId">
                <option [ngValue]="defaultBatch.id">
                  {{defaultBatch.name}}
                </option>
                <option *ngFor="let moduleBatch of moduleBatches" [ngValue]="moduleBatch.id">
                  {{moduleBatch.name}}
                </option>
              </select>
              <button type="button" data-toggle="dropdown" aria-expanded="false" title="Batch"
                class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
                  class="fa fa-info-circle"></i></button>
              <div class="info-popup dropdown-menu p-2">
                <p class="form-info-p">Only students in this batch are invited. All Batches covers everyone enrolled on the course.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <quill-editor placeholder="Enter Summary" classes="ql-container--lg event-summary" required [(ngModel)]="mailBody"
        [ngModelOptions]="{standalone: true}"></quill-editor>
      <div class="card-footer p-0 mt-4">
        <div class="d-flex justify-content-around">
          <div class="row">
            <div class="col-md-5">
              <button type="submit" class="btn btn--warning m-1" (click)="testInviteMail()"
                title="Sends the invitation to your own address so you can check how it looks"
                [disabled]="disableButtons">Test
                Event Invitation</button>
            </div>
            <div class="col-lg-5">
              <button type="submit" class="btn m-1" [disabled]="disableButtons"
                title="Sends a calendar invitation to the students in the batch above, the course tutors and you"
                (click)="sendInviteMail()">Send Event
                Invitation</button>
            </div>


          </div>

        </div>
      </div>
    </form>
  </div>
</div>
